import React, { useEffect, useRef, useState } from "react";
import Header from "../sharedFiles/header/header";
import { useDispatch, useSelector } from "react-redux";
import {
  AddOpprId,
  emptyCart,
  logoutUser,
  selectCart,
  selectCustomer,
  selectOpprID,
  selectUser,
  setCart,
  setCustomerCode,
  updateQuantity,
} from "../ReduxStore/userReducer";
import "./checkout.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import {
  PostCartItemApi,
  SoPostApi,
  removeItemInTable,
  PostSalesQuotation,
  CustomerDataApi,
  postQuationWithCustomer,
  postOrderWithCustomer,
  InsertSQOldOppr,
  UpdateGreeterStatus
} from "../API/API";
import SunspotLoader from "../sharedFiles/loader/loader";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";
import { fetchBranchList } from "../ReduxStore/reduxThunk";
import { Popover, TextField } from "@mui/material";
import { GetData } from "../API/getApi";
import Footer from "../sharedFiles/footer/footer";
import { PostData, PostWithoutData } from "../API/postApi";
import { CustomCheckbox } from "../sharedFiles/customCheckbox/customCheckBox";
import { CRMPostData, resetCrmData } from "../ReduxStore/actions";
import SharedCrm from "../sharedFiles/sharedCrm/sharedCrm";
import { updateSQ } from "../API/API";
import { GetGuestCode } from "../API/Greeter/GreeterThunk";
import { useSharedCrm } from "../itemPage/sharedCrmContext";
const Checkout = () => {
  // const {GetSalesPersonData } = useSelector(state => state.greeterData);
  const checkout = useSelector(selectCart);
  
  const { formData, setFormData,validateForm} = useSharedCrm();
  const customerData = useSelector(selectCustomer);
  const OpprId = useSelector(selectOpprID);
  const [customer, setCustomer] = useState([]);
  const BranchNames = useSelector((state) => state.item.BranchList);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  // const [CustomerValue, setCustomerValue] = useState(false);
  
  const dispatch = useDispatch();
  const [DueDate, setDueDate] = React.useState(dayjs());
  const Ddate = dayjs(DueDate).format("YYYY-MM-DD");
  const [isLoading, setIsLoading] = useState(false);
  const [valueChange, setValueChange] = useState(false);
  const [remarks, setRemarks] = useState("");
  const userData = useSelector(selectUser);
  const databaseName = userData?.DatabaseName;
  const userId = userData?.UserId;
  const jwtToken = userData?.JwtToken;
  const WhsCode = userData?.WhsCode;
  const [customerYes, setCustomerYes] = useState("");
  const [error, setError] = React.useState("");
  const navigate = useNavigate();
  const [custCatError, setCustcatError] = useState("");
  // const [custNmeError, setCustNamError] = useState("");
  // const [estimatedDateError, setEstimatedDateError] = useState("");
  const [errorCount, setErrorCount] = useState(0);
  const crmPostData = useSelector((state) => state.item.CRMPostData);
  
  // const [PhoneError, setPhoneError] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const thead = [
    "itemCode",
    "itemName",
    "cntUnitMsr",
    "itmsGrpCod",
    "lastPurPrc",
    "onHand",
    "quantity",
    "Action",
  ];
  const location = useLocation();
  const linedata = JSON.parse(localStorage.getItem('DocEntry'));
const docEntry =linedata?.DocEntry;
const opportunityNos =linedata?.Opportunity_No;
useEffect(() => {
  if (crmPostData) {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...crmPostData,
    }));
    if (crmPostData.existingcust) {
      setCustomerYes(crmPostData.existingcust);
    }
  }
}, [crmPostData]);
  const orderType = location.state?.orderType;
  // useEffect(() => {
  //   // Set the customer data from the store if it exists on load
  //   if (customerData?.customerCode && customerData?.customerName) {
  //     setCustomerCodes(customerData.customerCode);
  //     setCustomerName(customerData.customerName);
  //     setCustPhoneNum(customerData.phoneNum);   
  //     setSearchTerm(
  //       `${customerData.customerCode}-${customerData.customerName}`
  //     );
  //   }
  //   if (customerData?.phoneNum) {
  //     setCustPhoneNum(customerData.phoneNum);
  //   }
  // }, [customerData]);
  // const handleSiteChange = (e) => {
  //   const { value } = e.target;
  //   setCustomerYes(value);
  //   if (value === "Yes") {
  //     const updatedFormData = {
  //       ...formData,
  //       CustomerName: "",  
  //   };        
  //   setFormData(updatedFormData);
  //   }
  //   if (value === "No") {
  //     setSearchTerm("");
  //     setCustPhoneNum("");
  //     dispatch(setCustomerCode(""))
  //   }
  // };


  // const handleCustomerName = (e) => {
  //   const { value, name } = e.target;
  //   setCustomerCreation((prev) => [{
  //     ...prev[0],
  //     customerName: value,
  //   }]);
  //   const updatedFormData = {
  //     ...formData,
  //     [name]: value,
  //     existingcust:value?"NO":"",
  //   };
  //   setCustomerYes(value ? "NO" : "");
  //   setFormData(updatedFormData);
  //   setFormDataError((prev) => ({
  //     ...prev,
  //     CustomerName: "",
  //   }));

  //   setErrorCount(0);
  //   dispatch(CRMPostData(updatedFormData));
  // };
  
  // const handleCustomerName = (e) => {
  //   const { value, name } = e.target;
  //   setCustomerCreation((prevCustomerCreation) => [
  //     {
  //       ...prevCustomerCreation[0],
  //       customerName: value,
  //     },
  //   ]); 
  //   const updatedFormData = {
  //     ...formData,
  //     [name]: value,
  //     existingcust:"NO"
  //   };
  //   setFormData(updatedFormData);
  //   if (value === "") {
  //     setCustomerYes("");
  //   } else {
  //     setCustomerYes("NO");
  //   }
  //   setCustomerYes("NO")
  //   dispatch(CRMPostData(updatedFormData));
  //   setFormDataError((prevErrors) => ({
  //     ...prevErrors,
  //     CustomerName: "",  // Clear the error for the field
  //   })); 
  //   setErrorCount(0);
  // };
  // const handlePhoneNumberChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormDataError((prevErrors) => ({
  //     ...prevErrors,
  //     [name]: "",  // Clear the error for the field
  //   }));
  //   if (/^\d*$/.test(value) && value.length <= 11) {
  //     setPhoneError(false);
  //     // Update the phone number in the customerCreation state
  //     const updatedFormData = {
  //       ...formData,
  //       PhoneNo: value, // This ensures that the correct field is updated
  //     };
      
  //     setFormData(updatedFormData);
  //     dispatch(CRMPostData(updatedFormData));
  //     setCustomerCreation((prevCustomerCreation) => [
  //       {
  //         ...prevCustomerCreation[0],
  //         PhoneNumber: value,
  //       },
  //     ]);
     
  //     // setFormData(updatedFormData);
  //   } else {
  //     setPhoneError(true);
  //   }
  // };

  const getGreeterCodeFromSession = () => {
    try {
      const sessionKeys = ["CRMPostData"];
  
      for (const key of sessionKeys) {
        const data = sessionStorage.getItem(key);
        if (data) {
          const parsed = JSON.parse(data);
          if (parsed?.GreeterCode) {
            return parsed.GreeterCode;
          }
        }
      }
  
      return null;
    } catch (err) {
      console.error("Error reading GreeterCode from session:", err);
      return null;
    }
  };
  

  const postGreeterStatus = async () => {
    // const greeterCode = getGreeterCodeFromSession(); 
    const greeterData = JSON.parse(sessionStorage.getItem("CRMPostData") || '{}');
    // if (!formData.GreeterCode) {
    //   setError("Select greeter code"); 
    //   return;
    // } else {
    //   setError("");
    // }
    if (!greeterData.GreeterCode) {
      return;
    }
    const apiUrl = `${UpdateGreeterStatus}?guestCode=${greeterData.GreeterCode}`;
  
    try {
      const response = await PostData(apiUrl, null, jwtToken, dispatch, navigate); 
    } catch (error) {
      console.error("Failed to update greeter status:", error);
    }
  };
  



  //******** This is for get a customer data from API *********//
  const GetCustomerData = async () => {
    try {
      const customerData = await GetData(
        `${CustomerDataApi}?databaseName=${databaseName}`,
        {
          headers: {
            wg_token: jwtToken,
          },
        },
        dispatch,
        navigate
      );
      setCustomer(customerData);
    } catch (error) {}
   
  };  
  //******** This is for get a branch list for add a branch id to final sap post *****/
  useEffect(() => {
    if (!BranchNames || BranchNames.length === 0) {
      dispatch(fetchBranchList(databaseName, jwtToken));
    }
    GetCustomerData();
  }, [BranchNames, databaseName, dispatch]);

  //********** Filter a user branch id by using a branch name *********/
  const userBranchName = userData?.Branch;
  const matchingBranch = BranchNames?.find(
    (branch) => branch.bplName === userBranchName
  );

  //************ handle a cart update on checkout page ***********/
  const handleUpdateCart = async () => {
    let checkoutArray = Object.values(checkout);
    checkoutArray = checkoutArray.map((item) => {
      let newItem = { ...item }; // Create a new object
      if (!newItem.salUnitMsr) {
        newItem.salUnitMsr = "0";
      }
      return newItem;
    });
    try {
      const responseData = await axios.post(
        PostCartItemApi + "userId=" + userId,
        checkoutArray,
        {
          headers: {
            wg_token: jwtToken,
          },
        }
      );
      if (responseData.data === "") {
        Swal.fire("Cart updated successfully!");
      }
      setValueChange(false);
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up the request:", error.message);
      }
    }
  };

  //******* This is for page navigation from checkout to itemPage ***********/
  const handleBackToDashboard = async () => {
    if (valueChange) {
      handleUpdateCart();
    }
    navigate("/GetGroupItem");
  };

  //******** This is for remove the cart item from table based on userif on successful final post  *******/
  const handleRemoveItem = async (event) => {
    const removeData = await PostWithoutData(
      `${removeItemInTable}userId=${userId}`,
      jwtToken,
      dispatch,
      navigate
    );
  };


 
  const { setSearchValue } = useSharedCrm();
 
  const handleSubmit = async (event) => {
    event.preventDefault(); 
    if (!validateForm()) {
      setErrorCount((count) => count + 1);
      return;
    }
    setCustcatError("");
    const checkoutArray = Object.values(checkout);
    // Convert checkout object to array
    //**** Updating a cart array for posting *********/
    // const isValidNumber = (value) => {
    //   console.log("value",value);
    //   return typeof value === "number" && !isNaN(value);
    // };
    const isValidNumber = (value) => {
      if (typeof value === "number" && !isNaN(value)) {
        return value; // already a valid number
      }
    
      if (typeof value === "string") {
        // Convert string to number
        const num = parseFloat(value);
        if (!isNaN(num)) {
          return num; // valid number
        }
      }
    
      return 0; // fallback if not a number
    };
    // const updatedCart =
    //   orderType && orderType === "Sales Order"
    //     ? checkoutArray.map((row) => ({
    //         customerCode: CustomerCode ? CustomerCode : row.customerCode,
    //         ItemCode: row.itemCode,
    //         Price: isValidNumber(row.defaultPriceList)
    //           ? row.defaultPriceList
    //           : 0,
    //         Quantity: row.quantity,
    //         DeliveryDate: Ddate,
    //         Remarks: remarks,
    //         BranchId: matchingBranch?.bplId,
    //         WareHouseCode: WhsCode,
    //         SplCode: userData.slpCode,
    //       }))
    //     : checkoutArray.map((row) => ({
    //         customerCode: CustomerCode ? CustomerCode : row.customerCode,
    //         ItemCode: row.itemCode,
    //         Price: isValidNumber(row.defaultPriceList)
    //           ? row.defaultPriceList
    //           : 0,
    //         Quantity: row.quantity,
    //         ValidTillDate: Ddate,
    //         Remarks: remarks,
    //         BplId: matchingBranch?.bplId,
    //         WareHouseCode: WhsCode,
    //         SplCode: userData.slpCode,
    //       }));

    let previousLineId =0; // Initialize with the starting LineId value.

    const updatedCart =
      orderType && orderType === "Sales Order"
      ? checkoutArray.map((row) => ({
              CustomerCode: formData ? formData?.CustomerCode : row.CustomerCode,
              ItemCode: row.itemCode,
              Price: isValidNumber(row.defaultPriceList),
                priceListName : row?.priceListName,
              Quantity: row.quantity,
              DeliveryDate: Ddate,
              Remarks: remarks,
              BranchId: matchingBranch?.bplId,
              WareHouseCode: WhsCode,
              SplCode: userData.slpCode,
          
          }))
        : checkoutArray.map((row) => {
            return {
              CustomerCode: formData ? formData.CustomerCode : row.CustomerCode,
              ItemCode: row.itemCode,
              Price: isValidNumber(row.defaultPriceList),
                priceListName : row?.priceListName,
              Quantity: row.quantity,
              ValidTillDate: Ddate,
              Remarks: remarks,
              BplId: matchingBranch?.bplId,
              WareHouseCode: WhsCode,
              SplCode: userData.slpCode,
            };
          });
    
    const companyName = databaseName;
    //****** In this will add database name to cart item because posting a cart to sap by dynamic database *********/

    let dataToSend;
    const updatedFormData = {
      ...formData,
      ExecutiveId: formData.ExecutiveId || "-1",
      EstimatedValue: formData.EstimatedValue || 1000,
    };
    
    if (customerYes === "YES") {
      if (OpprId ) {
        dataToSend = {
          companyName: companyName,
          OpprId:OpprId.toString(),
          salesQuotations: updatedCart,
          post: [updatedFormData],
        };
      }else {
      dataToSend = {
        companyName: companyName,
        salesQuotations: updatedCart,
        post: [updatedFormData],
      };
      // console.log("dataToSend",dataToSend);
    }
    } else if (customerYes === "NO") {
      if (orderType && orderType === "Sales Order") {
        dataToSend = {
          companyName: companyName,
          customerData: {
            customerName: formData?.CustomerName,
            mobileNumber: formData?.PhoneNo,
          },
          post: [updatedFormData],
          quotationData: updatedCart,
          entryType: "customer",
        };
        // console.log("dataToSend",dataToSend);
      }else {
        dataToSend = {
          companyName: companyName,
          customerData: {
            customerName: formData?.CustomerName,
            mobileNumber:  formData?.PhoneNo,
          },
          post: [updatedFormData],
          quotationData: updatedCart,
          entryType: "Lead",
        };
      }
    }   
 
    //******* Dynamic API endpoint **********/
    let apiEndpoint;
    if (orderType === "Sales Quotation") {
      if (customerYes === "YES") {
        // If customerYes is "YES", use different endpoints based on OpprId
         // apiEndpoint = OpprId === "" ? PostSalesQuotation : InsertSQOldOppr;
        if(!OpprId){
          apiEndpoint = PostSalesQuotation
        } else {
          apiEndpoint =InsertSQOldOppr
        };
       
        // If customerYes is not "YES", use postQuotationWithCustomer
        // apiEndpoint = docEntry === "" && updateSQ ;
      } else {
        // If customerYes is not "YES", use postQuationWithCustomer
        apiEndpoint = postQuationWithCustomer;
      }
    }
    if (orderType === "Sales Order") {
      apiEndpoint =
        customerYes && customerYes === "YES"
          ? SoPostApi
          : postOrderWithCustomer;
    }
  try {
    setIsLoading(true);
  console.log("dataToSend",dataToSend,checkoutArray);
  
    const responseData = await PostData(
      apiEndpoint,
      dataToSend,
      jwtToken,
      dispatch,
      navigate
    );
  
    if (responseData === "OK") {
      const greeterData = JSON.parse(sessionStorage.getItem("CRMPostData") || '{}');
      if (greeterData.GreeterCode) {
        const apiUrl = `${UpdateGreeterStatus}?guestCode=${greeterData.GreeterCode}`;
        const response = await PostData(apiUrl, null, jwtToken, dispatch, navigate);
        if (response === "OK") {
          // toast.success("CRM successfully created!", {
          //   position: "bottom-right",
          //   theme: "dark",
          // });
        }
      }
      toast.success("Request successfully created!", {
        position: "top-center",
        theme: "dark",
      });
      dispatch(GetGuestCode({ slpCode: userData?.slpCode }));
      handleRemoveItem();
      sessionStorage.removeItem('CRMPostData');
      setSearchTerm("");
      setSearchValue(""); // only set once
      dispatch(emptyCart());
      dispatch(resetCrmData());
      navigate("/GetGroupItem")
      
    } else {
      toast.error(responseData, {
        position: "bottom-right",
        theme: "dark",
      });
    }
  
  } catch (error) {
    toast.error(error?.message || "Something went wrong!", {
      position: "bottom-right",
      theme: "dark",
    });
  } finally {
    setIsLoading(false);
  }
}
  
  
  
 const handleOldSQ =async () =>{
  setIsLoading(true);
  const checkoutArray = Object.values(checkout);
  const isValidNumber = (value) => {
    return typeof value === "number" && !isNaN(value);
  };
 const updatedCart = checkoutArray.map((row) => {
    // console.log("row",row);
      return {
        ItemCode: row.itemCode,
        Price: isValidNumber(row.defaultPriceList)
          ? row.defaultPriceList
          : 0,
        Quantity: row.quantity,
        Remarks: remarks,
        priceList:row?.PriceList,
        BplId: matchingBranch?.bplId,
        discountPercentage:row?.discountPercantage,
        WareHouseCode: WhsCode,
        SplCode: userData.slpCode,
      };
    });
 const dataToSend = {
    companyName: databaseName,
    docEntry :docEntry,
    salesQuotations: updatedCart,
  }
  try {
    const responseData = await PostData(
      updateSQ,
      dataToSend,
      jwtToken,
      dispatch,
      navigate
    );
    if (responseData === "OK") {
      handleRemoveItem();
      sessionStorage.removeItem('CRMPostData')
      // sessionStorage.removeItem('CRMPostDatass')
      setIsLoading(false);
      toast("Request successfully created!", {
        position: "bottom-right",
        theme: "dark",
      });
      setSearchTerm("");
      dispatch(emptyCart());
      dispatch(resetCrmData());
      // dispatch(setCustomerCode({ customerCode: "",
      //   customerName: "",
      //   phoneNum: "" }));  
    } else {
      setIsLoading(false);
      toast(responseData, {
        position: "bottom-right",
        theme: "dark",
      });
    }
  } catch (error) {
    setIsLoading(false);     
        toast(error.message, {
        position: "bottom-right",
        theme: "dark",
    });
  }
  setIsLoading(false);
 }
  //******* This will render a empty cart page **********/
  if (!checkout || Object.keys(checkout).length === 0) {
    return (
      <div className="">
        <Header />
        <div className="dashImage"></div>
        <div className="cartEmptyDiv">
          <div className="backIconDiv">
            <a onClick={handleBackToDashboard} className="backIcon">
              <ArrowCircleLeftIcon />
            </a>
            <p className="emptyname col-12">Item Page</p>
          </div>
          <div className="cartEmptyBg">
            <div className="cartEmpty">
              <div className="cartEmptyImage"></div>
              <p className="cartEmpty-text">
                Oops! There is no Item in your cart
              </p>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={3000}
        limit={1}/>
        <Footer />
      </div>
    );
  }
  //****** This is for delete item in cart *********/
  const handleButtonClick = (e, itemCode) => {
    const newQuantity = 0;
    dispatch(updateQuantity({ itemCode, newQuantity }));
    setValueChange(true);
  };

  //****** This is for increase the quantity of items  ********/
  const handleQuantityChange = (e, itemCode) => {
    const newQuantity = e.target.value;
    dispatch(updateQuantity({ itemCode, newQuantity }));
    setValueChange(true);
    // Update the state here...
  };

  //******* This will calculate a total price of the cart item  ******/
  const newCheckout = Object.fromEntries(
    Object.entries(checkout).map(([key, item]) => [
      key,
      { ...item, total: item.defaultPriceList * item.quantity },
    ])
  );

  

  //****** This will handle a text field values change getting a search term ***********/
  const handleCustInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value === "") {
      setCustomerYes("");
    }
    setIsDropdownVisible(true);
  };

  //****** This will help to show the dropdown while click the input field *****/
  const handleInputClick = () => {
    setIsDropdownVisible(true);
  };
  //******* This will filter a customer data as per input values  ********/
  let filteredData = [];
  if (Array.isArray(customer) && searchTerm.length > 3) {
    filteredData = customer.filter(
      (item) =>
        (item.customerCode &&
          item.customerCode.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.customerName &&
          item.customerName.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }
  //****** On final click on dropdown will get a customer name and customer code  ******/
  // const handleItemClick = async (customerCode, customerName,phoneNum) => {
  //   setCustomerCodes(customerCode);
  //   setCustomerName(customerName);
  //   setCustPhoneNum(phoneNum);
  //   setSearchTerm(`${customerCode}-${customerName}`);
  //   // setSearchTerm("");
  //   setCustomerCreation((prevCustomerCreation) => [
  //     {
  //       ...prevCustomerCreation[0],
  //       customerName: customerName,
  //       PhoneNumber:phoneNum,
  //       customerCode:customerCode
  //     },
  //   ]);
  //   dispatch(setCustomerCode({ customerCode: customerCode,
  //      customerName: customerName,
  //      phoneNum: phoneNum }));
  //   // setCustomerValue(true);
  //   setCustomerYes("YES");
  //   setIsDropdownVisible(false);
  // };
  // const handleLeadLevelClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleLeadLevelClose = () => {
  //   setAnchorEl(null);
  // };

  // const handleLeadLevelSelect = (value) => {
  //   const updatedFormData = {
  //     ...formData,
  //     LeadLevel: value,
  //   };
  //   setFormData(updatedFormData);
  //   dispatch(CRMPostData(updatedFormData));
  //   handleLeadLevelClose();
  // };

  const opens = Boolean(anchorEl);
  const id = opens ? "simple-popover" : undefined;

  // Get keys and add 'total' to keys
  const keys = Object.keys(newCheckout[Object.keys(newCheckout)[0]]);
  // Calculate the total sum
  let totalSum = Object.values(newCheckout).reduce(
    (sum, item) => sum + item.total,
    0
  );

  return (
    <div>
      <Header />
      <div className='dashBoardMain'>
      <div className="dashImage"></div>
      <div className="dashGradient"></div>
      <div className="sqHistorydiv ">
        <div className="CheckbackIconDiv">
          <div className="d-flex justify-content-start mt-3 mt-md-2 mt-xl-2 mt-xxl-2">
            <a onClick={handleBackToDashboard} className="backIcon">
              <ArrowCircleLeftIcon />
            </a>
            <p className="checkoutName col-12">
              {orderType && orderType === "Sales Order"
                ? "Sales order Checkout"
                : "Sales Quotation Checkout"}
            </p>
          </div>
          <div className="DateCustomerDiv col-10 col-md-7 col-xl-5 justify-content-md-end justify-content-xl-end col-xxl-4 justify-content-xxl-end">
            <div className="CheckDatePicker">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={
                    orderType && orderType === "Sales Order"
                      ? "Delivery Date"
                      : "Valid Till Date"
                  }
                  className="PRPicker"
                  value={DueDate}
                  minDate={dayjs()}
                  onChange={(newValue) => {
                    setDueDate(newValue);
                  }}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>
            </div>
            {/* <div className="customerDiv col-6 col-xl-8">
              <TextField
                type="text"
                label="Customer Name"
                className="checkCust"
                value={searchTerm || ""}
                onClick={handleInputClick}
                onChange={handleCustInputChange}
                variant="standard"
                autoComplete="off"
                disabled={customerYes === "NO"}
              />
              {isDropdownVisible && searchTerm && (
                <ul className="binUl">
                  {filteredData.map((item, index) => (
                    <li
                      key={index}
                      onClick={() =>
                        handleItemClick(item.customerCode, item.customerName, item.phoneNum)
                      }
                    >
                      {item.customerCode}-{item.customerName}
                    </li>
                  ))}
                </ul>
              )}
            </div> */}
          </div>
        </div>
        <div className="col-12 col-xl-12 col-xxl-10 d-flex gap-3 gap-xl-2 gap-xxl-4 maindiv">
          <div className="checkoutItem col-12 col-md-9 col-xl-10 col-xxl-12">
            <div>
              {Object.values(newCheckout).map((item, index) => (
                <div key={index} className="CheckMainDiv">
                  {/* <div className='itemImageDiv'></div> */}
                  <div className="itemdataDiv">
                    <div className="ItemName">
                      <p className="itemcodeP">{item.itemCode} -</p>
                      <p>{item.itemName}</p>
                    </div>
                    <div className="ItemQtyDiv">
                      <input
                        value={item.quantity}
                        onChange={(e) => handleQuantityChange(e, item.itemCode)}
                        onClick={(e) => e.target.select()}
                      />
                      <div className="column-action">
                        <Tooltip title="Delete">
                          <button
                            onClick={(e) => handleButtonClick(e, item.itemCode)}
                          >
                            <DeleteForeverIcon />
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  <div className="priceValue">
                    {/* {console.log("item :", item)} */}
                    {Number(item.total).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              ))}
              <div className=" position-relative">
                <div className="totalSum">
                  <p className="">Sub Total</p>
                  <p className="cell-content">{totalSum.toLocaleString()}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="placeOrderDiv col-11 col-md-3 col-xl-2 col-xxl-2">
            {/* <p>place order </p> */}
            <div className="Existing-Customer">
              
              <div>
                {/* <div className="existing-customer-check">
                  {SiteValues.map((value) => (
                    <div key={value} className="sitevistDiv  ">
                      <CustomCheckbox
                        checked={customerYes === value}
                        onChange={handleSiteChange}
                        value={value}
                        name="SiteVist"
                      />
                      <label htmlFor="">{value}</label>
                    </div>
                  ))}
                </div> */}
                <div className="customer-creation">
                  <SharedCrm 
                  formData={formData}
                  setFormData={setFormData} 
                  customerYes = {customerYes}
                  customer ={customer} 
                  />
                </div>
              </div>
            </div>
            <div className="final-placeorder-div">
              <div className="subTotalDiv">
                <p className="m-0">Sub Total</p>
                <p className=" m-0 cell-content">{totalSum.toLocaleString()}</p>
              </div>
              <div className=" remarksDiv d-flex flex-column ">
                {/* <label htmlFor="" >Remarks</label> */}
                <textarea
                  name=""
                  className="Remark-textArea"
                  id=""
                  placeholder="Remarks"
                  onChange={(e) => {
                    setRemarks(e.target.value);
                  }}
                ></textarea>
              </div>
              <div className="placeOrderButtonDiv">
                {/* <button onClick={handleRemoveItem}>reset</button> */}
                {valueChange ? (
                  <button onClick={handleUpdateCart}>Update Cart</button>
                ) : (
                  <button
                    // onClick={handleSubmit}
                    onClick={docEntry && docEntry ? handleOldSQ : handleSubmit}
                    disabled={(customerYes === "" && !docEntry)}
                    className=""
                  >
                    {orderType && orderType === "Sales Order"
                      ? "Place a Order"
                      : "Place Quotation"}
                  </button>
                )}
                {/* <button onClick={handleRemoveItem}>reset</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer 
      />
      {isLoading && (
        <div className="loader position-absolute ">
          (<SunspotLoader />)
        </div>
      )}
      </div>
      <Footer />
    </div>
  );
};

export default Checkout;
